export default __webpack_public_path__ + "static/speculative1-91cad99382c9f5043c3eea8bd0e0d4d1.png";